import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";

import {createUseStyles} from "react-jss";
import UISpinner from "~/old-ui/UISpinner";
import UIIcon from "~/old-ui/UIIcon";
import {greenColor, orangeColor, redColor} from "~/theme";

const UIToast = React.forwardRef(({loading, success, warning, danger, text, closable, onClose, arrow, className, ...props}, ref) => {
  const classes = useStyles();

  return (
    <div ref={ref} className={cn(classes.root, {
      [classes.withIcon]: loading || success || danger,
      [classes.closable]: closable,

      [classes.arrow]: !!arrow,

      [classes.arrowTop]: arrow && arrow.startsWith('top'),
      [classes.arrowBottom]: arrow && arrow.startsWith('bottom'),
      [classes.arrowLeft]: arrow && arrow.startsWith('left'),
      [classes.arrowRight]: arrow && arrow.startsWith('right'),

      [classes.arrowStart]: arrow && arrow.endsWith('-start'),
      [classes.arrowEnd]: arrow && arrow.endsWith('-end'),
    }, className)} {...props}>
      {loading && (<UISpinner className={classes.icon}/>)}
      {success && (<UIIcon name='fa-check' className={cn(classes.icon, classes.successIcon)}/>)}
      {danger && (<UIIcon name='fa-exclamation-triangle' className={cn(classes.icon, classes.errorIcon)}/>)}
      {warning && (<UIIcon name='fa-exclamation-triangle' className={cn(classes.icon, classes.warningIcon)}/>)}

      <div className={classes.text}>{text}</div>

      {closable && (
        <UIIcon
          className={classes.closeIcon}
          name='fa-times'
          onClick={onClose}
        />
      )}
    </div>
  )
});

export default UIToast;

UIToast.propTypes = {
  loading: PropTypes.bool,
  success: PropTypes.bool,
  danger: PropTypes.bool,

  text: PropTypes.any,
  closable: PropTypes.bool,
  onClose: PropTypes.func,

  arrow: PropTypes.oneOf([
    'top-start',
    'top-end',
    'left-start',
    'left-end',
    'right-start',
    'right-end',
    'bottom-start',
    'bottom-end'
  ])
};


const useStyles = createUseStyles({
  root: {
    backgroundColor: 'rgba(0,0,0,.8)',
    position: 'relative',
    color: '#fff',
    display: 'flex',
    alignItems: 'flex-start',
    padding: [[10, 10, 9]],
    borderRadius: 6,
  },

  arrow: {
    '&:before': {
      content: '" "',
      position: 'absolute',
      width: 0,
      height: 0,
      border: [[8, 'solid', 'transparent']],
    }
  },

  arrowStart: {},
  arrowEnd: {},

  arrowTop: {
    '&:before': {
      top: -16,
      borderBottomColor: 'rgba(0,0,0,.8)',
    },

    '&.$arrowStart:before': {
      left: 10,
    },

    '&.$arrowEnd:before': {
      right: 10
    }
  },

  arrowLeft: {
    '&:before': {
      left: -16,

      borderRightColor: 'rgba(0,0,0,.8)',
    },

    '&.$arrowStart:before': {
      top: 10,
    },

    '&.$arrowEnd:before': {
      bottom: 10
    }
  },


  arrowRight: {
    '&:before': {
      right: -16,

      borderLeftColor: 'rgba(0,0,0,.8)',
    },

    '&.$arrowStart:before': {
      top: 10,
    },

    '&.$arrowEnd:before': {
      bottom: 10
    }
  },

  arrowBottom: {
    '&:before': {
      bottom: -16,
      borderTopColor: 'rgba(0,0,0,.8)',
    },

    '&.$arrowStart:before': {
      left: 10,
    },

    '&.$arrowEnd:before': {
      right: 10
    }
  },


  closable: {
    paddingRight: 28,
  },

  icon: {
    width: 16,
    minWidth: 16,
    height: 16,
    marginTop: 1,

    marginRight: 8,
  },

  successIcon: {
    color: greenColor,
  },

  warningIcon: {
    color: orangeColor,
  },

  dangerIcon: {
    color: redColor,
  },

  closeIcon: {
    width: 12,
    height: 12,
    position: 'absolute',
    right: 8,
    top: 12,
    cursor: 'pointer',
    color: 'rgba(255,255,255,.8)',

    '&:hover,&:focus': {
      color: '#fff'
    }
  }
});
